<template>
  <v-form class="expande-horizontal wrap pa-3 centraliza" ref="form">
    <v-flex xs12 md10 class="py-6">
      <div class="expande-horizontal centraliza column wrap">
        <v-img
          src="logo.jpg"
          alt="logo"
          height="150px"
          contain
        />
        <span class="pt-3 fonte" style="color: #444;">
          Faça o login abaixo
        </span>
      </div>
    </v-flex>

    <v-flex class="ma-1 mb-0" xs12 md6>
      <v-text-field
        label="E-mail"
        placeholder="ex: email@gmail.com"
        :color="$theme.primary"
        outlined
        dense
        rounded
        :rules="[v => !!v || 'Preencha este campo']"
        v-model="payload.username"
        autocomplete="new-login"
      >
      </v-text-field>
    </v-flex>

    <v-flex class="ma-1 mt-0" xs12 md6>
      <v-text-field
        label="Senha"
        placeholder="Digite sua senha"
        :color="$theme.primary"
        outlined
        rounded
        dense
        @click:append="typePass = !typePass"
        :append-icon="typePass ? 'mdi-eye' : 'mdi-eye-off'"
        @keyup.enter="validaCampo"
        :type="typePass ? 'text' : 'password'"
        :rules="[v => !!v || 'Preencha este campo']"
        v-model="payload.senha"
        autocomplete="new-senha"
      >
      </v-text-field>
    </v-flex>

    <v-flex class="ma-1 mb-6" xs12 md6>
      <div class="expande-horizontal centraliza">
        <v-btn
          block
          rounded
          class="white--text px-12 elevation-0 fonte"
          dark
          :color="$theme.primary"
          @click="validaCampo"
          >Entrar</v-btn
        >
      </div>
    </v-flex>
    <v-flex class="ma-1 mb-6" xs12 md6>
      <div class="expande-horizontal centraliza column">
        <v-btn
          text
          depressed
          :color="$theme.secondary"
          @click="$router.push('/cadastro')"
          class="fonte mb-3"
          small
        >
          <span>
            Faça seu cadastro aqui
          </span>
        </v-btn>
        <v-btn
          :color="$theme.primary"
          @click="setModalForgotPassword(true)"
          text
          class="fonte text-lowercase grey--text"
        >
          <span class="fonte fonteMini">
            Recuperar senha
          </span>
        </v-btn>
      </div>
    </v-flex>

    <ForgotPass />
  </v-form>
</template>

<script>
import { mapActions } from "vuex";
import ForgotPass from "./ForgotPassword.vue";
export default {
  data() {
    return {
      payload: {
        username: "",
        senha: ""
      },
      typePass: false
    };
  },
  components: {
    ForgotPass
  },
  methods: {
    ...mapActions(["createSession", "setModalForgotPassword"]),
    validaCampo() {
      if (this.$refs.form.validate()) {
        this.createSession(this.payload);
      }
    },
    isAlreadyLogged() {
      if (this.$store.getters.getLoggedUser) {
        this.$router.push("/inicio-admin");
      }
    }
  },
  created() {
    this.isAlreadyLogged();
  }
};
</script>
